module.exports = __webpack_public_path__ + "img/AOK.1774f8a9.jpg";